(ns ycweb.app.blitz.manufacturing.manufacturing
  (:require
   [ycweb.components.forms :as forms]
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.components.grid :as grid]
   [ycweb.components.transitions :as t]
   [ycweb.components.flow :as flow]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.wrapper :as w]
   [ycweb.util.comms :as comms]
   [ycweb.components.common :as cmn]))

(def steps
  (forms/setup-steps
    [{:key :list-orders :title "Choose Order to Manufacture"}
     {:key :list-items :title "BOM Recipe"}
     {:key :qty-select :title "Select Qty to Build"}
     {:key :box-select :title "Select Outer Box to Use"}
     {:key :location-scan :title "Pack Location"}
     {:key :printer-scan :title "Printer"}
     {:key :finished :title "Finished"}]))

(defmethod flow/barcode-dispatch-screen :manufacturing/finished [_ app-atom scan]
  (grid/dispatch-action app-atom :manufacturing/printer-scan {:scan scan}))

(rum/defc finished < rum/reactive [app-atom]
  (w/wrapper app-atom "Manufacturing" {:steps steps :step :finished}
    [[:div
      {:class (u/bem :section [:medium])}
      [:h2.u-text-center
       {:class (u/bem :heading [:large])}
       [:b "Thank you!"]]
      [:i.u-block-center
       {:class (u/bem :icon [:3-3 :emoticon-happy :enormous :block])}]
      [:div.u-margin-top-24
       [:p.u-text-center
        {:class (u/bem :paragraph [:flush :large])}
        [:b "Move the packed Gift Boxes to a shelf"]]]]]

    [[:aside.page-body__footer
      [:p.paragraph.paragraph--flush.u-text-center
       "Scan a printer to reprint"]]]
    (grid/pos-call-to-action
      {:single-fn
       #(grid/dispatch-action app-atom :manufacturing/list-orders {})})))

(defmethod flow/render-screen :manufacturing/finished [app-atom _]
  (finished app-atom))

(defmethod comms/receive :manufacturing/printer-scan [app-atom {:keys [delivery-uuid location-id]}]
  (toaster/close-subtle-progress app-atom)
  (t/transition-next app-atom :manufacturing/finished))

(defmethod grid/action :manufacturing/printer-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [order delivery-uuid location-id build-qty box-variation-id]} (get-in @app-atom [:manufacturing])]
    (comms/send :manufacturing/printer-scan
      {:printer-name scan
       :delivery-uuid delivery-uuid
       :order-id (:clientorder-id order)
       :qty build-qty
       :box-variation-id box-variation-id
       :location-id location-id})))

(defmethod flow/barcode-dispatch-screen :manufacturing/printer-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :manufacturing/printer-scan {:scan scan}))

(defmethod grid/action :manufacturing/printer-scan-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :manufacturing/printer-scan
     :input-key :scan
     :input-type :barcode}))

(defn printer-scan-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :manufacturing/printer-scan-menu-barcode}

      {:label "Cancel"
       :action :manufacturing/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc printer-screen < rum/reactive [app-atom]
  (w/wrapper app-atom "Manufacturing"
    {:modal-fn printer-scan-menu-modal
     :steps steps :step :printer-scan}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Printer"]
      grid/barcode-icon]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-text "Scan Printer"
       :right-plain true})))

(defmethod flow/render-screen :manufacturing/printer-scan [app-atom screen]
  (printer-screen app-atom))

(defmethod comms/receive :manufacturing/location-scan [app-atom {:keys [delivery-uuid location-id]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :manufacturing assoc
    :delivery-uuid delivery-uuid
    :location-id location-id)
  (t/transition-next app-atom :manufacturing/printer-scan))

(defmethod grid/action :manufacturing/location-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :manufacturing/location-scan {:scan scan}))

(defmethod flow/barcode-dispatch-screen :manufacturing/location-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :manufacturing/location-scan {:scan scan}))

(defmethod grid/action :manufacturing/location-scan-menu-barcode [app-atom config _]
  (grid/single-input-modal app-atom
    {:title "Capture manual barcode"
     :field-text "Barcode"
     :initial-value ""
     :save-text "Capture"
     :save-key :manufacturing/location-scan
     :input-key :scan
     :input-type :barcode}))

(defn location-scan-menu-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Manual Barcode"
       :action :manufacturing/location-scan-menu-barcode}

      {:label "Cancel"
       :action :manufacturing/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc location-screen < rum/reactive [app-atom]
  (w/wrapper app-atom "Manufacturing"
    {:modal-fn location-scan-menu-modal
     :steps steps :step :location-scan}
    [[:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Scan Pack Desk"]
      grid/barcode-icon
      [:div
       [:i.u-block-center
        {:class
         (u/bem
           :icon
           [:2-1 :location :light-force :large :block])}]]]]
    []
    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-text "Scan Location"
       :right-plain true})))

(defmethod flow/render-screen :manufacturing/location-scan [app-atom screen]
  (location-screen app-atom))

(rum/defc box-select < rum/reactive [app-atom]
  (let [outer-boxes (cmn/curact app-atom [:manufacturing :outer-boxes])]
    (w/wrapper app-atom "Manufacturing" {:steps steps :step :box-select}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Select Outer Box"]
        (forms/select
          "Select box:"
          (rum/cursor-in app-atom [:manufacturing :box-variation-id])
          (concat
            [{:text "- Select -" :value nil}]
            (map
              (fn [box]
                {:value (:id box) :text (:name box)})
              outer-boxes)))

        [:div]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn #(t/transition-next app-atom :manufacturing/location-scan)
         :right-text "Next"}))))

(defmethod flow/render-screen :manufacturing/box-select [app-atom screen]
  (box-select app-atom))

(rum/defc qty-select < rum/reactive [app-atom]
  (let [{:keys [build-qty order]} (cmn/curact app-atom [:manufacturing])
        error? (and build-qty (or (> build-qty 20) (> build-qty (:qty (:bom order)))))]
   (w/wrapper app-atom "Manufacturing" {:steps steps :step :qty-select}
         [[:div.section
           [:h2.u-text-center
            {:class (u/bem :heading [:standard])}
            "Qty to Build"
            [:span.u-hidden-from-view " - "]
            [:span.heading__subtext (str " Ordered total: " (:qty (:bom order)))]]
           (forms/input "Qty:" "10" (rum/cursor-in app-atom [:manufacturing :build-qty])
             {:type :number
              :required? true
              :error error?
              :hint (str "Note: maximum is " (min 20 (:qty (:bom order))))})

           [:div]]]
         []
         (grid/pos-call-to-action
           {:left-fn #(t/transition-prev app-atom)
            :right-fn
            (when (and build-qty (not error?))
              #(t/transition-next app-atom :manufacturing/box-select))
            :right-text "Next"}))))

(defmethod flow/render-screen :manufacturing/qty-select [app-atom screen]
  (qty-select app-atom))

(rum/defc item-slat < rum/reactive
  [{:keys [bom-qty product] :as bob}]
  [:article.slat-wrapper
   [:div.slat
    {:class (u/bem :picking-slat [:neutral])}
    [:div.picking-slat__info
     [:h3
      {:class (u/bem :picking-slat__title [:large])}
      [:b product " "]
      [:span.picking-slat__subtext
       "Qty: " [:b bom-qty]]]]]])

(rum/defc list-items < rum/reactive [app-atom]
  (let [{:keys [product items]} (cmn/curact app-atom [:manufacturing :order :bom])]
    (w/wrapper app-atom "Manufacturing" {:steps steps :step :list-items}
      [[:div.section
        [:div.u-margin-top-24
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          [:span.heading__pretext.heading "Recipe for:"]
          product
          [:span.heading__subtext
           "List of items and qtys"]]]]
       [[:div.slats
         (map item-slat items)]]]
      []
      (grid/pos-call-to-action
        {:left-fn #(grid/dispatch-action app-atom :manufacturing/list-orders {})
         :right-text "Next"
         :right-fn #(t/transition-next app-atom :manufacturing/qty-select)}))))

(defmethod flow/render-screen :manufacturing/list-items [app-atom _]
  (list-items app-atom))

(defmethod grid/action :manufacturing/list-items [app-atom order _]
  (swap! app-atom assoc-in [:manufacturing :order] order)
  (t/transition-next app-atom :manufacturing/list-items))

(rum/defc order-slat < rum/reactive
  [{:keys [status bom ycnumber]} {:keys [on-click]}]
  (let [{:keys [product qty items]} bom]
    [:article.slat.transfer-order-slat
     {:on-click (when on-click on-click)}
     [:header.transfer-order-slat__header
      [:div.transfer-order-slat__title-wrapper
       [:h1.transfer-order-slat__title
        [:span.transfer-order-slat__order-no product]]]]
     [:ul.transfer-order-slat__details
      [:li.transfer-order-slat__notes ycnumber]]
     [:ul.transfer-order-slat__details
      [:li.transfer-order-slat__notes
       "Gift boxes to make: " [:b qty]]]

     [:ul.transfer-order-slat__details
      [:li.transfer-order-slat__item-count "SKUs in each box: " [:b (count items)]]
      [:li.transfer-order-slat__status
       (println bom)
       [(case status
          "Ready"
          :span.u-text-status-success
          :span.u-text-status-warning) [:b status]]]]]))

(rum/defc list-orders < rum/reactive [app-atom]
  (let [orders (cmn/curact app-atom [:manufacturing :orders])]
    (w/wrapper app-atom "Manufacturing" {:steps steps :step :list-orders}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Choose an Order"]]
       [:div.slats
        (->>
          orders
          (map
            (fn [order]
              (order-slat order
                {:on-click
                 #(grid/dispatch-action app-atom :manufacturing/list-items order)}))))]]
      []
      (grid/pos-call-to-action
        {:left-fn #(t/transition-next app-atom :main-menu)
         :right-plain true}))))

(defmethod flow/render-screen :manufacturing/list-orders [app-atom _]
  (list-orders app-atom))

(defmethod comms/receive :manufacturing/list-orders [app-atom {:keys [outer-boxes orders]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update :manufacturing assoc
    :build-qty nil
    :box-variation-id nil
    :outer-boxes outer-boxes
    :orders orders)
  (t/transition-next app-atom :manufacturing/list-orders))

(defmethod grid/action :manufacturing/list-orders [app-atom _ _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :manufacturing/list-orders {}))
